module.exports = __webpack_public_path__ + "img/apr.30ef68bf.png";